import http from '@/common/utils/http-common';
import { History } from '@/types/History.type';

class HistoryService {
  create(data: History) {
    return http.post('/histories', data);
  }

  export(params?: any) {
    return http.get('/histories/export', params);
  }

  getHistoryLatestPlaces() {
    return http.get('/histories/latest-places');
  }
}

export default new HistoryService();
